var React = require('react');

function Close (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M13.314 11.955L23.53 22.21a.998.998 0 0 1 0 1.409.99.99 0 0 1-1.403 0L11.91 13.364 1.694 23.619a.99.99 0 0 1-1.403 0 .998.998 0 0 1 0-1.41l10.216-10.254L.291 1.7a.998.998 0 0 1 0-1.41.99.99 0 0 1 1.403 0L11.91 10.547 22.126.292a.99.99 0 0 1 1.404 0 1 1 0 0 1 0 1.409L13.314 11.955z"}));
}

Close.displayName = "Close";

Close.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/close.svg
// module id = 1264
// module chunks = 0